/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
	Container,
	Box,
	Flex,
	Text,
	Center,
	Tabs,
	TabList,
	TabPanels,
	Tab,
	TabPanel,
	Button,
	SimpleGrid,
	useToast,
	Divider,
	useDisclosure,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	TableContainer as ChakraTableContainer,
	Table as ChakraTable,
	Thead as ChakraThead,
	Tbody as ChakraTbody,
	Tr as ChakraTr,
	Th as ChakraTh,
	Td as ChakraTd,
} from '@chakra-ui/react';
import { gql, useLazyQuery, useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowRight, faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { usePartneredCompanyStore } from '../../../../components/ManageAgentPartner/Miscellaneous/IntermediaryStore';
import DownloadAndViewButton from '../../../../components/Files/DownloadAndViewButton';
import ProfessionalIndividualList from '../components/ProfessionalIndividualList';
import SaleProfessionalList from './components/SaleProfessionalList';
import UpdateIntermediaryPartnerStatus from '../components/UpdateIntemediaryPartnerStatus';
import Loading from '../../../../components/Loading';
import NoData from '../../../../components/NoData';
import LabelDetail from '../../../../components/LabelDetail';
import CompanyName from '../../../../components/CompanyName';
import IntermediaryStatus from '../../../../components/ManageAgentPartner/Miscellaneous/IntermediaryStatus';
import LocalizedDate from '../../../../components/LocalizedDate';
import IntermediaryModel from '../../../../components/ManageAgentPartner/Miscellaneous/IntermediaryModel';
import formatMoneyKH from '../../../../utils/formatMoneyKH';
import useStore from '../../../../store';
import useMoment from '../../../../hooks/useMoment';
import c from '../../../../constant';
import EventLoggingButton from '../../../../components/ManageAgentPartner/Modal/EventLoggingButton';

const Q_GET_REQUESTS = gql`
	query get($id: String!) {
		getIntermediaryRequestForPartnerById(id: $id) {
			id
			number
			status
			adminStatus
			paymentStatus
			paymentData
			createdAt
			createdBy
			startedAt
			updatedAt
			type
			signedContractDueDate
			company {
				id
				name
				nameKhmer
				logo
				type
			}
			details {
				id
				requestId
				partnerId
				partnerType
				model
				boardLetter
				insuranceCompanyContract
				signedInsuranceCompanyContract
				terminationLetterWithOldCompany
				completedLetter
				status
				company {
					id
					name
					nameKhmer
					type
					logo
				}
				description
				oldModel
				oldCompany {
					id
					name
					nameKhmer
					type
					logo
				}
				requesterCompany {
					id
					name
					nameKhmer
					type
					logo
				}
			}
		}
	}
`;

const M_NEXT = gql`
	mutation next($id: String!, $requestDate: String, $solarDate: String, $lunarDate: String) {
		nextStepIntermediaryPartnerReview(id: $id, requestDate: $requestDate, solarDate: $solarDate, lunarDate: $lunarDate)
	}
`;

const LABEL_WIDTH = '150px';
const direct = 'direct';
const reference = 'ref';

function AgentCompanyPartneringModal({ id = null, onModalClose = () => null }) {
	const toast = useToast();
	const setPermitted = usePartneredCompanyStore((state) => state.setPermitted);
	const { t } = useTranslation();
	const { push } = useHistory();
	const { paperLunarDateString, paperSolarDateString, paperGeneralDateString } = useMoment();
	const { currentUser: user } = useStore((state) => state.currentUser);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { isPermitted } = usePartneredCompanyStore((state) => state.isPermitted);
	const [data, setData] = useState(null);
	const [pfCompletedList, setPfCompletedList] = useState([]);
	const [pfCompleted, setPfCompleted] = useState(false);
	const [loadData, { loading, data: loadedData, error: loadedError }] = useLazyQuery(Q_GET_REQUESTS);
	const [submitToNextStep, { error: errorNext, loading: loadingNext, data: dataNext }] = useMutation(M_NEXT);

	useEffect(() => {
		loadData({ variables: { id } });
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (loadedError) {
			if (loadedError?.graphQLErrors?.length > 0) {
				loadedError?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'bottom-right',
					})
				);
			} else {
				toast({
					title: t(loadedError?.message ? loadedError?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'bottom-right',
				});
			}
		}
	}, [loadedError]);

	useEffect(() => {
		if (errorNext) {
			if (errorNext?.graphQLErrors?.length > 0) {
				errorNext?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'bottom-right',
					})
				);
			} else {
				toast({
					title: t(errorNext?.message ? errorNext?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'bottom-right',
				});
			}
		}
	}, [errorNext]);

	useEffect(() => {
		if (loadedData) {
			let tmpData = [];
			loadedData?.getIntermediaryRequestForPartnerById?.details?.forEach((item) => {
				let isCompleted = false;
				if (item?.status !== null) {
					isCompleted = true;
				}
				tmpData.push({ ...item, isCompleted });
			});
			setData({ ...loadedData?.getIntermediaryRequestForPartnerById, details: tmpData });
		}
	}, [loadedData]);

	useEffect(() => {
		if (data?.adminStatus && user?.position) {
			setPermitted(data?.adminStatus, user?.position);
		}
	}, [data, user]);

	function updateIntemediaryPartnerData(e) {
		const tmpData = [];
		data?.details?.forEach((item) => {
			if (item?.id === e?.id) {
				let isCompleted = false;
				if (e?.status !== null) {
					isCompleted = true;
				}
				tmpData.push({ ...e, isCompleted });
			} else {
				tmpData.push(item);
			}
		});
		setData({ ...data, details: tmpData });
	}

	function isCompletedPartner(data) {
		let isCompleted = true;
		data?.details?.forEach((item) => {
			if (!item?.isCompleted) {
				isCompleted = false;
			}
		});
		return isCompleted;
	}

	useEffect(() => {
		let isCompleted = true;
		for (var id in pfCompletedList) {
			if (!pfCompletedList[id]) {
				const currentItem = data?.details?.find((e) => e?.id === id);
				if (currentItem?.status !== 'rejected') {
					isCompleted = false;
				}
			}
		}
		setPfCompleted(isCompleted);
	}, [pfCompletedList, data]);

	useEffect(() => {
		if (dataNext?.nextStepIntermediaryPartnerReview) {
			refresh();
		}
	}, [dataNext]);

	function refresh() {
		setData(null);
		setPfCompletedList([]);
		setPfCompleted(false);
		setTimeout(() => {
			loadData({
				variables: {
					id,
				},
			});
		}, 100);
	}

	return (
		<>
			<Modal scrollBehavior="inside" size="6xl" isOpen={true} onClose={onModalClose}>
				<ModalOverlay backdropFilter="auto" bg="blackAlpha.300" backdropBlur="2px" />
				<ModalContent borderRadius={c.borderRadius} p="4">
					<Flex justifyContent="flex-end">
						<ModalCloseButton />
						<Button
							size="sm"
							onMouseDown={() => push(`/intermediary/partner-request/detail?type=new&id=${id}`)}
							borderRadius={c.borderRadius}
							mr="10"
							mt="-2"
						>
							{t('Open Full Page')}
						</Button>
					</Flex>
					<ModalBody>
						<>
							<Container maxW="container.xl" mt="16px" mb="16px">
								<Center mt="5">
									<Box
										w="100%"
										bg="white"
										borderRadius={c.borderRadius}
										border="1px solid #dbdbdb"
										boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
										pb="16px"
									>
										<Flex
											alignItems="center"
											justifyContent="space-between"
											bg="#FAFAFA"
											p="16px"
											pt="8px"
											pb="8px"
											mb="16px"
											borderBottom="1px solid #dbdbdb"
										>
											<Flex w="100%" justifyContent="space-between" alignItems="center">
												<Text fontSize="x-large" fontWeight="bold" mr="4">
													{t('Detail')}
												</Text>
												{data?.id && (
													<Flex justifyContent="flex-end" alignItems="center">
														<EventLoggingButton label="Logs" typeObjectId={id} />
														<Button
															onClick={onOpen}
															leftIcon={<FontAwesomeIcon icon={faFileInvoice} style={{ fontSize: 16 }} />}
															colorScheme="gray"
															variant="solid"
															size="sm"
															borderRadius={c.borderRadius}
															border="1px solid #bdc3c7"
															ml={2}
														>
															{t('Payment')}
														</Button>
														<>
															{data?.adminStatus !== 'completed' && (
																<>
																	{isPermitted && (
																		<>
																			<Button
																				isLoading={loadingNext}
																				isDisabled={!isCompletedPartner(data) || !pfCompleted}
																				rightIcon={
																					<FontAwesomeIcon
																						icon={
																							data?.adminStatus === 'reviewing_contract_by_office'
																								? faCheck
																								: faArrowRight
																						}
																						style={{ fontSize: 16 }}
																					/>
																				}
																				colorScheme="blue"
																				variant="solid"
																				size="sm"
																				borderRadius={c.borderRadius}
																				border="1px solid #bdc3c7"
																				ml={2}
																				onMouseDown={() => {
																					if (isCompletedPartner(data) && pfCompleted) {
																						submitToNextStep({
																							variables: {
																								id: data?.id,
																								requestDate: paperGeneralDateString(data?.startedAt, 'ឆ្នាំ'),
																								solarDate: paperSolarDateString(),
																								lunarDate: paperLunarDateString(),
																							},
																						});
																					}
																				}}
																			>
																				{t(data?.adminStatus === 'reviewing_contract_by_office' ? 'Done' : 'Submit')}
																			</Button>
																		</>
																	)}
																</>
															)}
														</>
													</Flex>
												)}
											</Flex>
										</Flex>
										<Box p="16px" pt="8px" pb="8px" mb="16px">
											{loading && (
												<>
													<Loading />
												</>
											)}
											{!loading && !data && (
												<>
													<NoData />
												</>
											)}
											{!loading && data && (
												<>
													<SimpleGrid columns={[1, null, 2]} spacingX={8}>
														<LabelDetail
															mb={1}
															mt={0}
															labelWidth={LABEL_WIDTH}
															direction="row"
															label="Number"
															titleDetail={data?.number}
														/>
														<LabelDetail
															mb={1}
															mt={0}
															labelWidth={LABEL_WIDTH}
															direction="row"
															label="Created By"
															childDetail={<CompanyName company={data?.company} />}
														/>
														<LabelDetail
															mb={1}
															mt={0}
															labelWidth={LABEL_WIDTH}
															direction="row"
															label="Started At"
															childDetail={<LocalizedDate dateString={data?.startedAt} />}
														/>
														<LabelDetail
															mb={1}
															mt={0}
															labelWidth={LABEL_WIDTH}
															direction="row"
															label="Status"
															childDetail={<IntermediaryStatus status={data?.adminStatus} />}
														/>
														{data?.adminStatus === 'completed' && (
															<>
																<LabelDetail
																	mb={1}
																	mt={0}
																	labelWidth={LABEL_WIDTH}
																	direction="row"
																	label="Completed At"
																	childDetail={<LocalizedDate dateString={data?.updatedAt} />}
																/>
															</>
														)}
														{data?.adminStatus === 'expired' && (
															<>
																<LabelDetail
																	mb={1}
																	mt={0}
																	labelWidth={LABEL_WIDTH}
																	direction="row"
																	label="Expired At"
																	childDetail={<LocalizedDate dateString={data?.signedContractDueDate} />}
																/>
															</>
														)}
													</SimpleGrid>
													<Tabs variant="enclosed" mt={4}>
														<TabList>
															{data?.details?.map((item, index) => (
																<>
																	<Tab key={index}>{t(item?.partnerType)}</Tab>
																</>
															))}
														</TabList>
														<TabPanels>
															{data?.details?.map((item, index) => (
																<TabPanel key={index} borderWidth={1} borderStyle="solid" borderColor="gray.200">
																	<SimpleGrid columns={[1, null, 2]} spacingX={8}>
																		{item?.oldCompany?.id && (
																			<>
																				<LabelDetail
																					mb={1}
																					mt={0}
																					label="Old Partnered Insurance Company"
																					childDetail={<CompanyName company={item?.oldCompany} color="red.500" />}
																				/>
																			</>
																		)}
																		{item?.oldCompany?.id && (
																			<>
																				<LabelDetail
																					mb={1}
																					mt={0}
																					label="Model"
																					childDetail={<IntermediaryModel model={item?.oldModel} color="red" />}
																				/>
																			</>
																		)}
																		<LabelDetail
																			mb={1}
																			mt={0}
																			label={
																				item?.oldCompany?.id
																					? 'New Partnered Insurance Company'
																					: 'Partnered Insurance Company'
																			}
																			childDetail={<CompanyName company={item?.company} />}
																		/>
																		<LabelDetail
																			mb={1}
																			mt={0}
																			label="Model"
																			childDetail={<IntermediaryModel model={item?.model} />}
																		/>
																		{item?.terminationLetterWithOldCompany?.url && (
																			<>
																				<LabelDetail
																					mb={1}
																					mt={0}
																					label="Letter of Termination"
																					childDetail={
																						<DownloadAndViewButton
																							url={item?.terminationLetterWithOldCompany?.url}
																							size={item?.terminationLetterWithOldCompany?.size}
																							marginLeft={0}
																						/>
																					}
																				/>
																			</>
																		)}
																		{item?.terminationLetterWithOldCompany?.url && (
																			<>
																				<>&nbsp;</>
																			</>
																		)}
																		<LabelDetail
																			mb={1}
																			mt={0}
																			label="Board of Directors Decision"
																			childDetail={
																				<DownloadAndViewButton
																					url={item?.boardLetter?.url}
																					size={item?.boardLetter?.size}
																					marginLeft={0}
																				/>
																			}
																		/>
																		<LabelDetail
																			mb={1}
																			mt={0}
																			label="Draft Service Partnership Agreement with Insurance Company"
																			childDetail={
																				<DownloadAndViewButton
																					url={item?.insuranceCompanyContract?.url}
																					size={item?.insuranceCompanyContract?.size}
																					marginLeft={0}
																				/>
																			}
																		/>
																		{item?.signedInsuranceCompanyContract?.url && (
																			<LabelDetail
																				mb={1}
																				mt={0}
																				label="Signed Service Partnership Agreement with Insurance Company"
																				childDetail={
																					<DownloadAndViewButton
																						url={item?.signedInsuranceCompanyContract?.url}
																						size={item?.signedInsuranceCompanyContract?.size}
																						marginLeft={0}
																					/>
																				}
																			/>
																		)}
																	</SimpleGrid>
																	<Divider mb={2} mt={4} />
																	<SimpleGrid columns={[1, null, 2]} spacingX={8}>
																		<LabelDetail
																			mb={1}
																			mt={0}
																			label="Decision"
																			childDetail={
																				<UpdateIntermediaryPartnerStatus
																					id={item?.id}
																					status={item?.status}
																					onCallback={(e) => updateIntemediaryPartnerData(e)}
																				/>
																			}
																		/>
																		{item?.status === 'approved' && item?.completedLetter?.url && (
																			<LabelDetail
																				mb={1}
																				mt={0}
																				label="Approval Letter"
																				childDetail={
																					<DownloadAndViewButton
																						url={c.baseFilePath + item?.completedLetter?.url}
																						marginLeft={0}
																					/>
																				}
																			/>
																		)}
																		{item?.status === 'rejected' && item?.completedLetter?.url && (
																			<LabelDetail
																				mb={1}
																				mt={0}
																				label="Refusal Letter"
																				childDetail={
																					<DownloadAndViewButton
																						url={c.baseFilePath + item?.completedLetter?.url}
																						marginLeft={0}
																					/>
																				}
																			/>
																		)}
																		{item?.status === 'rejected' && (
																			<LabelDetail
																				mb={1}
																				mt={0}
																				label="Reason of Rejection"
																				childDetail={
																					<Text fontSize="md" fontWeight="normal" color="red.400">
																						{t(item?.description) || 'N/A'}
																					</Text>
																				}
																			/>
																		)}
																	</SimpleGrid>
																	{item?.model === direct && item?.requesterCompany?.type !== 'INSURANCE_BROKER' && (
																		<>
																			<Divider mb={4} mt={4} />
																			<LabelDetail
																				mb={0}
																				mt={2}
																				label="Professional Individual List"
																				childDetail={
																					<Box w="100%" mt={1}>
																						<ProfessionalIndividualList
																							id={item?.id}
																							callback={(e) =>
																								setPfCompletedList({
																									...pfCompletedList,
																									[e?.id]: e?.isCompleted,
																								})
																							}
																							type={item?.oldCompany?.id ? 'change' : 'new'}
																						/>
																					</Box>
																				}
																			/>
																		</>
																	)}
																	{item?.model === reference && item?.requesterCompany?.type !== 'INSURANCE_BROKER' && (
																		<>
																			<Divider mb={4} mt={4} />
																			<LabelDetail
																				mb={0}
																				mt={2}
																				label="Sale Staff List"
																				childDetail={
																					<Box w="100%" mt={1}>
																						<SaleProfessionalList
																							id={item?.id}
																							onCallback={(e) =>
																								setPfCompletedList({
																									...pfCompletedList,
																									[e?.id]: e?.isCompleted,
																								})
																							}
																							emptyLabel="No Sale Staff Selected"
																						/>
																					</Box>
																				}
																			/>
																		</>
																	)}
																</TabPanel>
															))}
														</TabPanels>
													</Tabs>
												</>
											)}
										</Box>
									</Box>
								</Center>
							</Container>
						</>
					</ModalBody>
				</ModalContent>
			</Modal>
			<Modal size="lg" isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent borderRadius={c.borderRadius}>
					<ModalHeader>{t('Payment')}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<ChakraTableContainer>
							<ChakraTable size="sm">
								<ChakraThead>
									<ChakraTr>
										<ChakraTh>{t('Label')}</ChakraTh>
										<ChakraTh isNumeric>{t('Amount')}(KHR)</ChakraTh>
										<ChakraTh isNumeric>Trx.ID</ChakraTh>
									</ChakraTr>
								</ChakraThead>
								<ChakraTbody>
									{data?.paymentData?.map((item, index) => {
										return (
											<ChakraTr key={index}>
												<ChakraTd>{item?.label}</ChakraTd>
												<ChakraTd isNumeric>{formatMoneyKH(parseFloat(item?.amount))}</ChakraTd>
												<ChakraTd
													isNumeric
													cursor={user.role === 'admin' ? 'pointer' : 'default'}
													_hover={{ textDecoration: user.role === 'admin' ? 'underline' : 'none' }}
													onMouseDown={() => user.role === 'admin' && push(`/payment?page=1&trxId=${item?.tranId}`)}
												>
													{item?.tranId}
												</ChakraTd>
											</ChakraTr>
										);
									})}
								</ChakraTbody>
							</ChakraTable>
						</ChakraTableContainer>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
}

export default AgentCompanyPartneringModal;
